/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthInformationAliases {
  ALLERGIES_FIELD = 'allergies-field',
  ALLERGY_TEXT_AREA = 'allergy-text-area',
  FIELD_BLOOD_GROUP = 'field-blood-group',
  HEALTH_FORM = 'health-form',
  HEALTH_INFOR_FETCH = 'health-infor-fetch',
  HEIGHT_FIELD = 'height-field',
  HEIGHT_INPUT = 'height-input',
  INPUT_BLOOD_TYPE = 'input-blood-type',
  LAYOUT_ROOT = 'layout-root',
  PANEL_HEALTH = 'panel-health',
  WEIGHT_FIELD = 'weight-field',
  WEIGHT_INPUT = 'weight-input',
}
export { HealthInformationAliases };
